import * as RNWeb from 'react-native-web';
import { PermissionsAndroid, TurboModuleRegistry, requireNativeComponent } from './NativeMocks.web';

// Re-export everything from react-native-web
export * from 'react-native-web';

// Add missing exports that are commonly used in RN but not in RNWeb
export { PermissionsAndroid, TurboModuleRegistry, requireNativeComponent };

// Create a default export that contains all named exports to support 'import RN from "react-native"'
const ReactNative = {
  ...RNWeb,
  PermissionsAndroid,
  TurboModuleRegistry,
  requireNativeComponent,
};

export default ReactNative;
